<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'maInspectDeviceDialog',
})
</script>
<template>
	<ma-data-table
		:key="visible + ''"
		v-model:visible="visible"
		row-key="id"
		:title="t('componentsModule.maInspectDevice.selectDevice')"
		url="/maku/biz_inspect_device/page"
		method="get"
		:multiple="true"
		:columns="[
			{ field: 'id', label: t('componentsModule.maInspectDevice.deviceId') },
			{ field: 'name', label: t('componentsModule.maInspectDevice.deviceName') },
			{ field: 'orgName', label: t('componentsModule.maInspectDevice.department') }
		]"
		:query-params="[
			{ field: 'name', label: t('componentsModule.maInspectDevice.deviceName'), type: 'input' },
			{ field: 'orgId', label: t('componentsModule.maInspectDevice.department'), type: 'orgBiz' }
		]"
		@select="onSelect"
	></ma-data-table>
</template>

<script setup lang="ts" name="maInspectDeviceDialog">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	}
})

const visible = defineModel<boolean>()

const emit = defineEmits(['select'])
const onSelect = (rows: any[]) => {
	emit('select', rows)
}
</script>
